/* eslint-disable */
import axios from 'axios';
import { useState } from 'react';
import ApiEndpoints from '../../const/ApiEndpoints';
import useProject from '../Project/useProject';
import useModelUpload from '../../Hooks/ModelUpload/useModelUpload';
import useCommon from '../../Hooks/useCommon';

const BASE_URL = ApiEndpoints.MODULE_BASE_URL.DOC;
const totalPageCount = 'x-total-count';

export default function useTaskManager() {
  const { dispatch, setUnseenNotificationCount } = useCommon();
  const [pipelineListTotalCount, setPipelineListTotalCount] = useState(0);
  const [pipelineListPageCount, setPipelineListPageCount] = useState(0);
  const [pipelineList, setPipelineList] = useState([]);

  const [resultListTotalCount, setResultListTotalCount] = useState(0);
  const [resultListPageCount, setResultListPageCount] = useState(0);
  const [resultList, setResultList] = useState([]);

  const [documentListTotalCount, setDocumentListTotalCount] = useState(0);
  const [documentListPageCount, setDocumentListPageCount] = useState(0);
  const [documentList, setDocumentList] = useState([]);

  const [taskListTotalCount, setTaskListTotalCount] = useState(0);
  const [taskListPageCount, setTaskListPageCount] = useState(0);
  const [taskList, settaskList] = useState([]);

  const [myTaskListTotalCount, setMyTaskListTotalCount] = useState(0);
  const [myTaskListPageCount, setMyTaskListPageCount] = useState(0);
  const [myTaskList, setMytaskList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const {
    project,
    fetchGroups,
    fetchUserProjects,
    createNewProject,
    fetchUserRecipients,
    fetchProjectTypes,
    markProjectCompleted,
    activateProject,
  } = useProject();
  const { fetchAllModelListWithoutPagination } = useModelUpload();

  const fetchPipelinesWithPagination = (
    taskId,
    pageIndex = 0,
    pageSize = 10,
    searchText = '',
    sortField,
    sortOrder,
    projectId,
    field
  ) => {
    setIsLoading(true);
    return axios
      .get(BASE_URL + ApiEndpoints.TASK_MANAGER.GET_TASK_PIPELINE, {
        params: {
          page_index: pageIndex + 1,
          ...(taskId ? { task_id: taskId } : {}),
          ...(pageSize ? { page_size: pageSize } : {}),
          ...(searchText !== '' ? { search_index: searchText } : {}),
          ...(sortField ? { sort_field: sortField } : {}),
          ...(sortOrder ? { sort_order: sortOrder } : {}),
          ...(field ? { fields: field } : {}),
          ...(projectId ? { project_id: projectId } : {}),
        },
      })
      .then(
        (res) => {
          if (res?.data?.pipelines) {
            setPipelineList(res?.data?.pipelines);
            setPipelineListTotalCount(res.headers[totalPageCount]);
            setPipelineListPageCount(
              Math.ceil(res?.headers?.[totalPageCount] / pageSize)
            );
          } else {
            setPipelineList([]);
            setPipelineListTotalCount(0);
            setPipelineListPageCount(0);
          }
          setIsLoading(false);
          return res;
        },
        (error) => {
          setIsLoading(false);
          throw error;
        }
      );
  };

  const fetchResultsWithPagination = (
    taskId,
    pageIndex = 0,
    pageSize = 10,
    searchText = '',
    sortField,
    sortOrder,
    projectId,
    field
  ) => {
    setIsLoading(true);
    return axios
      .get(BASE_URL + ApiEndpoints.TASK_MANAGER.GET_TASK_RESULTS, {
        params: {
          page_index: pageIndex + 1,
          ...(taskId ? { task_id: taskId } : {}),
          ...(pageSize ? { page_size: pageSize } : {}),
          ...(searchText !== '' ? { search_index: searchText } : {}),
          ...(sortField ? { sort_field: sortField } : {}),
          ...(sortOrder ? { sort_order: sortOrder } : {}),
          ...(field ? { fields: field } : {}),
          ...(projectId ? { project_id: projectId } : {}),
        },
      })
      .then(
        (res) => {
          if (res?.data?.pipeline_results) {
            setResultList(res?.data?.pipeline_results);
            setResultListTotalCount(res.headers[totalPageCount]);
            setResultListPageCount(
              Math.ceil(res?.headers?.[totalPageCount] / pageSize)
            );
          } else {
            setResultList([]);
            setResultListTotalCount(0);
            setResultListPageCount(0);
          }
          setIsLoading(false);
          return res;
        },
        (error) => {
          setIsLoading(false);
          throw error;
        }
      );
  };

  const fetchDocumentsWithPagination = (
    taskId,
    pageIndex = 0,
    pageSize = 10,
    searchText = '',
    sortField,
    sortOrder,
    field,
    modelId = null,
    projectId
  ) => {
    setIsLoading(true);
    return axios
      .get(BASE_URL + ApiEndpoints.TASK_MANAGER.GET_TASK_DOCUMENT, {
        params: {
          page_index: pageIndex + 1,
          ...(taskId ? { task_id: taskId } : {}),
          ...(pageSize ? { page_size: pageSize } : {}),
          ...(searchText !== '' ? { search_index: searchText } : {}),
          ...(sortField ? { sort_field: sortField } : {}),
          ...(sortOrder ? { sort_order: sortOrder } : {}),
          ...(field ? { fields: field } : {}),
          ...(modelId ? { model_id: modelId } : {}),
          ...(projectId ? { project_id: projectId } : {}),
        },
      })
      .then(
        (res) => {
          if (res?.data?.document_list) {
            setDocumentList(res?.data?.document_list);
            setDocumentListTotalCount(res.headers[totalPageCount]);
            setDocumentListPageCount(
              Math.ceil(res?.headers?.[totalPageCount] / pageSize)
            );
          } else {
            setDocumentList([]);
            setDocumentListTotalCount(0);
            setDocumentListPageCount(0);
          }
          setIsLoading(false);
          return res;
        },
        (error) => {
          setIsLoading(false);
          throw error;
        }
      );
  };

  const fetchTasksWithPagination = (
    filterByProjectId = null,
    projectId,
    pageIndex = 0,
    pageSize = 10,
    modelId,
    milestone,
    searchText = '',
    taskType,
    sortField,
    sortOrder
  ) => {
    setIsLoading(true);
    return axios
      .get(BASE_URL + ApiEndpoints.TASK_MANAGER.GET_TASK_LIST, {
        params: {
          ...(filterByProjectId
            ? { project_filter_id: filterByProjectId }
            : {}),
          ...(projectId ? { project_id: projectId } : {}),
          page_index: pageIndex + 1,
          ...(pageSize ? { page_size: pageSize } : {}),
          ...(modelId !== 'All Models' ? { model_id: modelId } : {}),
          ...(milestone !== 'All Status' ? { milestone: milestone } : {}),
          ...(taskType !== 'All Task Type' ? { task_type: taskType } : {}),
          ...(searchText !== '' ? { search_index: searchText } : {}),
          ...(sortField ? { sort_field: sortField } : {}),
          ...(sortOrder ? { sort_order: sortOrder } : {}),
        },
      })
      .then(
        (res) => {
          if (res?.data?.task_list) {
            settaskList(res?.data?.task_list);
            setTaskListTotalCount(res.headers[totalPageCount]);
            setTaskListPageCount(
              Math.ceil(res?.headers?.[totalPageCount] / pageSize)
            );
          } else {
            settaskList([]);
            setTaskListTotalCount(0);
            setTaskListPageCount(0);
          }
          setIsLoading(false);
          return res;
        },
        (error) => {
          setIsLoading(false);
          throw error;
        }
      );
  };

  const fetchTasksWithoutPagination = (projectId, field = null) => {
    setIsLoading(true);
    return axios
      .get(BASE_URL + ApiEndpoints.TASK_MANAGER.GET_TASK_LIST, {
        params: {
          ...(projectId ? { project_id: projectId } : {}),
          ...(field ? { fields: field } : {}),
        },
      })
      .then(
        (res) => {
          return res;
        },
        (error) => {
          setIsLoading(false);
          throw error;
        }
      );
  };

  const fetchMyTasksWithPagination = (
    projectId,
    pageIndex = 0,
    pageSize = 10,
    modelId,
    milestone,
    searchText = '',
    taskType,
    sortField,
    sortOrder,
    userId
  ) => {
    setIsLoading(true);
    return axios
      .get(BASE_URL + ApiEndpoints.TASK_MANAGER.GET_TASK_LIST, {
        params: {
          ...(projectId ? { project_id: projectId } : {}),
          page_index: pageIndex + 1,
          ...(pageSize ? { page_size: pageSize } : {}),
          ...(modelId !== 'All Models' ? { model_id: modelId } : {}),
          ...(milestone !== 'All Status' ? { milestone: milestone } : {}),
          ...(taskType !== 'All Task Type' ? { task_type: taskType } : {}),
          ...(searchText !== '' ? { search_index: searchText } : {}),
          ...(sortField ? { sort_field: sortField } : {}),
          ...(sortOrder ? { sort_order: sortOrder } : {}),
          ...(userId ? { user_id: userId } : {}),
        },
      })
      .then(
        (res) => {
          if (res?.data?.task_list) {
            setMytaskList(res?.data?.task_list);
            setMyTaskListTotalCount(res.headers[totalPageCount]);
            setMyTaskListPageCount(
              Math.ceil(res?.headers?.[totalPageCount] / pageSize)
            );
          } else {
            setMytaskList([]);
            setMyTaskListTotalCount(0);
            setMyTaskListPageCount(0);
          }
          setIsLoading(false);
          return res;
        },
        (error) => {
          setIsLoading(false);
          throw error;
        }
      );
  };

  const createTask = (payload) => {
    return axios
      .post(BASE_URL + ApiEndpoints.TASK_MANAGER.CREATE_TASK, payload)
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const getTaskListByMilestone = (projectId, milestone, userId) => {
    return axios
      .get(BASE_URL + ApiEndpoints.TASK_MANAGER.GET_TASK_LIST, {
        params: {
          milestone: milestone,
          user_id: userId,
          ...(projectId ? { project_id: projectId } : {}),
        },
      })
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const getTaskDetails = (taskId, projectId, overview) => {
    return axios
      .get(BASE_URL + ApiEndpoints.TASK_MANAGER.GET_TASK_DETAILS, {
        params: {
          ...(taskId ? { task_id: taskId } : {}),
          ...(projectId ? { project_id: projectId } : {}),
          ...(overview ? { overview: overview } : {}),
        },
      })
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const taskUpdate = (payload) => {
    return axios
      .post(BASE_URL + ApiEndpoints.TASK_MANAGER.TASK_UPADTE, payload)
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const publishDocumentToTask = (payload) => {
    return axios
      .post(BASE_URL + ApiEndpoints.TASK_MANAGER.PUBLISH_DOCUMENT, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const publishPipelineToTask = (payload) => {
    return axios
      .post(BASE_URL + ApiEndpoints.TASK_MANAGER.PUBLISH_SUIT, payload)
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const markExecutionAsFinal = (payload) => {
    return axios
      .post(BASE_URL + ApiEndpoints.TASK_MANAGER.MARK_AS_FINAL, payload)
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  // in-app notifications

  const fetchInAppNotifications = (
    pageIndex = 0,
    pageSize = 10,
    readStatus
  ) => {
    return axios
      .get(BASE_URL + ApiEndpoints.TASK_MANAGER.NOTIFICATIONS, {
        params: {
          page_index: pageIndex + 1,
          read_status: readStatus,
          ...(pageSize ? { page_size: pageSize } : {}),
        },
      })
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const fetchNotificationDetails = (payload) => {
    return axios
      .post(BASE_URL + ApiEndpoints.TASK_MANAGER.NOTIFICATIONS, payload)
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const clearAllNotifications = () => {
    return axios
      .delete(BASE_URL + ApiEndpoints.TASK_MANAGER.NOTIFICATIONS)
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const markNotificationAsRead = (payload) => {
    return axios
      .put(BASE_URL + ApiEndpoints.TASK_MANAGER.NOTIFICATIONS, payload)
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const deleteDocument = (payload) =>
    axios
      .delete(`${BASE_URL + ApiEndpoints.TASK_MANAGER.GET_TASK_DOCUMENT}`, {
        data: payload,
      })
      .then(
        (resp) => resp,
        (error) => {
          throw error;
        }
      );
  const deletePublishedPipeline = (payload) =>
    axios
      .delete(`${BASE_URL + ApiEndpoints.TASK_MANAGER.GET_TASK_PIPELINE}`, {
        data: payload,
      })
      .then(
        (resp) => resp,
        (error) => {
          throw error;
        }
      );
  const deletePublishedResult = (payload) =>
    axios
      .delete(`${BASE_URL + ApiEndpoints.TASK_MANAGER.GET_TASK_RESULTS}`, {
        data: payload,
      })
      .then(
        (resp) => resp,
        (error) => {
          throw error;
        }
      );
  const fetchUnseenNotificationCount = () => {
    return axios
      .get(BASE_URL + ApiEndpoints.TASK_MANAGER.NOTIFICATIONS, {
        params: {
          seen_status: true,
        },
      })
      .then(
        (res) => {
          dispatch(setUnseenNotificationCount(res?.data));
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };
  return {
    // Task Manager API calls
    createTask,
    fetchTasksWithPagination,
    getTaskDetails,
    taskUpdate,
    getTaskListByMilestone,
    fetchDocumentsWithPagination,
    publishPipelineToTask,
    publishDocumentToTask,
    fetchInAppNotifications,
    fetchNotificationDetails,
    clearAllNotifications,
    deleteDocument,
    markExecutionAsFinal,
    fetchResultsWithPagination,
    fetchMyTasksWithPagination,
    // other API calls
    fetchPipelinesWithPagination,
    fetchGroups,
    fetchUserRecipients,
    fetchAllModelListWithoutPagination,
    fetchUserProjects,
    createNewProject,
    fetchProjectTypes,
    // useful states
    project,
    pipelineListTotalCount,
    pipelineListPageCount,
    pipelineList,
    resultList,
    resultListPageCount,
    resultListTotalCount,
    documentListTotalCount,
    documentListPageCount,
    documentList,
    taskListPageCount,
    taskListTotalCount,
    taskList,
    myTaskListPageCount,
    myTaskListTotalCount,
    myTaskList,
    isLoading,
    fetchTasksWithoutPagination,
    markProjectCompleted,
    activateProject,
    deletePublishedPipeline,
    deletePublishedResult,
    markNotificationAsRead,
    fetchUnseenNotificationCount,
  };
}
